import React, { useState, useEffect } from "react";

import { Avatar, CardHeader, Tooltip, Box } from "@material-ui/core";
import { blue, green, orange } from "@material-ui/core/colors";
import AndroidIcon from "@material-ui/icons/Android";
import EmojiEmotionsIcon from "@material-ui/icons/EmojiEmotions";
import SettingsIcon from "@material-ui/icons/Settings";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import { getInitials } from "../../helpers/getInitials";
import { generateColor } from "../../helpers/colorGenerator";
import { i18n } from "../../translate/i18n";

import { getProfilePicUrl } from "../../services/api";

const TicketInfo = ({ contact, ticket, onClick }) => {
	const { user } = ticket
	const [userName, setUserName] = useState('')
	const [contactName, setContactName] = useState('')
	const [avatarKey, setAvatarKey] = useState(0); // ✅ FIX 05/12/2025: Key para forzar re-render del avatar

	useEffect(() => {
		if (contact) {
			setContactName(contact.name);
			if(document.body.offsetWidth < 600) {
				if (contact.name.length > 10) {
					const truncadName = contact.name.substring(0, 10) + '...';
					setContactName(truncadName);
				}
			}
		}

		if (user && contact) {
			setUserName(`${i18n.t("messagesList.header.assignedTo")} ${user.name}`);

			if(document.body.offsetWidth < 600) {
				setUserName(`${user.name}`);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contact, user])

	// ✅ FIX 05/12/2025: Forzar re-render del avatar cuando cambia profilePicUrl o updatedAt del prop contact
	useEffect(() => {
		const profilePicUrl = contact?.profilePicUrl;
		const updatedAt = contact?.updatedAt;

		if (profilePicUrl || updatedAt) {
			setAvatarKey(prev => prev + 1);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [contact?.profilePicUrl, contact?.updatedAt]);

	const presenceMessage = {
		composing: i18n.t("presence.composing"),
		recording: i18n.t("presence.recording"),
		available: "",
	};

	return (
		<CardHeader
			onClick={onClick}
			style={{ cursor: "pointer" }}
			titleTypographyProps={{ noWrap: true }}
			subheaderTypographyProps={{ noWrap: true }}
			avatar={
				<Avatar
					key={`avatar-${contact?.id}-${avatarKey}-${contact?.updatedAt || ''}`} // ✅ FIX 05/12/2025: Key dinámica con updatedAt para forzar re-render
					style={{ backgroundColor: generateColor(contact?.number || contact?.name || ""), color: "white", fontWeight: "bold" }}
					src={contact?.profilePicUrl && !contact.profilePicUrl.includes("nopicture.png")
						? `${getProfilePicUrl(contact.profilePicUrl)}?t=${avatarKey}-${contact?.updatedAt ? new Date(contact.updatedAt).getTime() : Date.now()}`
						: null}
					alt="contact_image"
					onError={(e) => {
						// Silenciar warning de carga de imagen (puede fallar por cache/CDN)
						if (e.target) {
							e.target.style.display = 'none';
						}
					}}
					onLoad={() => {}}
				>
					{getInitials(contact?.name || "")}
				</Avatar>
			}
			title={`${contactName} #${ticket.id}${contact?.number ? ` - ${contact.number}` : ''}`}
			subheader={
				<Box display="flex" alignItems="center" justifyContent="space-between">
					{/* ✅ FIX: Mostrar presence si está "composing" o "recording" */}
					{["composing", "recording"].includes(ticket?.presence) ? (
						<span style={{ color: green[600], fontWeight: "bold" }}>
							{presenceMessage[ticket.presence]}
						</span>
					) : (
						<span>{ticket.user && `${userName}`}</span>
					)}

					{/* ✅ INDICADORES DE AGENTE IA */}
					<Box display="flex" alignItems="center">
						{ticket.chatbot && (
							<Tooltip title="🤖 Agente IA - Chatbot activo">
								<AndroidIcon
									fontSize="small"
									style={{
										color: blue[600],
										fontSize: '16px',
										marginLeft: '5px'
									}}
								/>
							</Tooltip>
						)}

						{ticket.promptId && (
							<Tooltip title="🧠 IA Inteligente - Prompt configurado">
								<EmojiEmotionsIcon
									fontSize="small"
									style={{
										color: green[600],
										fontSize: '16px',
										marginLeft: '5px'
									}}
								/>
							</Tooltip>
						)}

						{ticket.useIntegration && (
							<Tooltip title="🔗 Integración Externa - N8N/Dialogflow">
								<SettingsIcon
									fontSize="small"
									style={{
										color: orange[600],
										fontSize: '16px',
										marginLeft: '5px'
									}}
								/>
							</Tooltip>
						)}

						{(ticket.flowStatus != null || ticket.queue?.flowBuilderId) && (
							<Tooltip title="🌊 FlowBuilder - Automatización de flujos activa">
								<AccountTreeIcon
									fontSize="small"
									style={{
										color: green[700],
										fontSize: '16px',
										marginLeft: '5px'
									}}
								/>
							</Tooltip>
						)}
					</Box>
				</Box>
			}
		/>
	);
};

export default TicketInfo;
